import React from 'react';
import { Space } from 'antd';
import { VehicleEnrichment, type VehicleSelectionValue } from '@/shared/components/VehicleEnrichment';
import { type RootVehicleRequest } from '@/features/guides/api/generated';

interface VehicleEditorProps {
  rootVehicle: Partial<RootVehicleRequest>;
  onUpdateVehicle: (selection: VehicleSelectionValue) => void;
}

export const VehicleEditor: React.FC<VehicleEditorProps> = ({
  rootVehicle,
  onUpdateVehicle,
}) => {
  return (
    <Space direction="vertical" style={{ width: '100%' }} size="large">
      <div style={{ maxWidth: '600px' }}>
        <VehicleEnrichment
          value={{
            manufacturer: rootVehicle.manufacturer ?? undefined,
            modelSeries: rootVehicle.modelSeries ?? undefined,
            engineBaseType: rootVehicle.engineBaseType as unknown as string,
            euroCode: rootVehicle.euroCode ?? undefined,
            modelYear: rootVehicle.modelYear ?? undefined,
          }}
          onChange={onUpdateVehicle}
        />
      </div>
    </Space>
  );
};